import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="summary-refresh"
export default class extends Controller {
  static targets = ["content", "overlay"]

  refresh() {
    if (this.hasContentTarget) {
      this.contentTarget.classList.add("blur-sm", "opacity-50", "pointer-events-none")
    }
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("hidden")
    }
  }
}
